export const SELECT_VARIANT = 'SELECT_VARIANT';
export const REMOVE_CART_ITEM = 'REMOVE_CART_ITEM';
export const SET_ALTERNATIVE_PRODUCTS_LINKS = 'SET_ALTERNATIVE_PRODUCTS_LINKS';
export const setAlternativeProductsLinksToState = (data) => {
    const action = {
        type: SET_ALTERNATIVE_PRODUCTS_LINKS,
        data: data
    };
    return action;
};
export const selectVariant = (newCode, variants) => {
    const oldVariant = variants.find(v => v.code !== newCode);
    const oldCode = oldVariant ? oldVariant.code : newCode;
    const action = {
        type: SELECT_VARIANT,
        newCode,
        oldCode,
    };
    return action;
};
export const toggleSelectedVariant = (currentSelectedVariantCode, variants) => {
    const variantCodes = variants.map(v => v.code);
    const newVariantCode = variantCodes[0] === currentSelectedVariantCode && variantCodes.length > 1 ? variantCodes[1] : variantCodes[0];
    return selectVariant(newVariantCode, variants);
};
